import { render, staticRenderFns } from "./QuestionChoices.vue?vue&type=template&id=71c6eddc&scoped=true&"
import script from "./QuestionChoices.vue?vue&type=script&lang=js&"
export * from "./QuestionChoices.vue?vue&type=script&lang=js&"
import style0 from "./QuestionChoices.vue?vue&type=style&index=0&id=71c6eddc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c6eddc",
  null
  
)

export default component.exports